export default __webpack_public_path__ + "static/media/lahore.dcf4ced6.png";